import * as React from 'react';
import { useState } from "react";
import CategoryForm from "../../components/Categories/CategoryForm/CategoryForm";
import Submenu from "../../components/Submenu/Submenu";
import AppMenus from "../../config/appMenus";
import AppRoutes from "../../config/appRoutes";
var Category = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var submenu = null;
    if (isEdit) {
        submenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editCategory.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? submenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(CategoryForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default Category;



//////////////////
// WEBPACK FOOTER
// ./src/views/Categories/Category.tsx
// module id = 331
// module chunks = 0